import React from 'react'
import { LoadPath, LoadProps } from './LoaderFactory'
import { Preferences } from '../types/models'

const PREFERENCES_ENDPOINT = '/api/preferences'
export const LoadPreferences: React.FC<LoadProps<Preferences>> = ({
  render
}) => <LoadPath<Preferences> path={PREFERENCES_ENDPOINT} render={render} />
